<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/crm-for-solopreneurs.mjs";
</script>
